import elemental from './elemental'
import enhancement from './enhancement'
import restoration from './restoration'

const shaman = { specs: [elemental, enhancement, restoration] }

export default shaman
